(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('she-recommendations')) return;

    class SheRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.__sheBound) return;
        this.__sheBound = true;

        // Bereits serverseitig gefüllt (Section Rendering API) — nichts zu tun.
        if (this.querySelector('.she-recs__inner')) return;
        if (!this.dataset.url) return;

        var self = this;
        var done = false;
        var run = function () {
          if (done) return;
          done = true;
          fetch(self.dataset.url)
            .then(function (r) {
              if (!r.ok) throw new Error(r.status);
              return r.text();
            })
            .then(function (html) {
              var tpl = document.createElement('template');
              tpl.innerHTML = html;
              var el = tpl.content.querySelector('she-recommendations');
              if (!el || !el.querySelector('.she-recs__inner')) return;
              self.innerHTML = el.innerHTML;
              // Warenkorb-Buttons der Karten neu binden (she-collection.js)
              document.dispatchEvent(new CustomEvent('she:collection:updated'));
            })
            .catch(function () {
              /* Keine Empfehlungen: Bereich bleibt leer. */
            });
        };

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(
            function (entries) {
              if (entries[0].isIntersecting) {
                io.disconnect();
                run();
              }
            },
            { rootMargin: '900px 0px' }
          );
          io.observe(this);
          setTimeout(run, 4000);
        } else {
          run();
        }
      }
    }

    customElements.define('she-recommendations', SheRecommendations);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["she-header"]) return;
  try {
    
(function(){
  var root=document.querySelector('[data-shx-root]'); if(!root) return;
  var body=document.body;
  var money=function(c){try{return (c/100).toLocaleString('de-DE',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'});}catch(e){return (c/100).toFixed(2)+' €';}};
  var moneyDec=function(v){var n=parseFloat(String(v).replace(/[^0-9.,-]/g,'').replace(',','.'));return isNaN(n)?'':money(Math.round(n*100));};
  function lock(){body.classList.add('shx-locked');}
  function unlock(){if(!document.querySelector('.shx-search.is-open,.shx-cartd.is-open,.shx-mob.is-open'))body.classList.remove('shx-locked');}
  function open(el){if(!el)return;el.hidden=false;requestAnimationFrame(function(){el.classList.add('is-open');});lock();}
  function close(el){if(!el)return;el.classList.remove('is-open');setTimeout(function(){el.hidden=true;unlock();},260);}

  /* Sticky shrink */
  var hdr=root.querySelector('[data-shx-header]');
  var onScroll=function(){hdr.classList.toggle('is-scrolled',window.scrollY>12);};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  /* Desktop mega: keyboard + touch support (hover is CSS) */
  root.querySelectorAll('[data-shx-item].has-mega').forEach(function(item){
    var trigger=item.querySelector('[data-shx-trigger]');
    var isTouch=window.matchMedia('(hover:none)').matches;
    if(trigger&&isTouch){
      trigger.addEventListener('click',function(e){
        var isBtn=(trigger.tagName==='BUTTON');
        if(item.classList.contains('is-open')){
          /* Punkt ohne eigenes Ziel: zweiter Tap schließt das Menü wieder. */
          if(isBtn){e.preventDefault();item.classList.remove('is-open');trigger.setAttribute('aria-expanded','false');}
          return;
        }
        e.preventDefault();
        root.querySelectorAll('[data-shx-item].is-open').forEach(function(o){if(o!==item){o.classList.remove('is-open');var ot=o.querySelector('[data-shx-trigger]');if(ot)ot.setAttribute('aria-expanded','false');}});
        item.classList.add('is-open');trigger.setAttribute('aria-expanded','true');
      });
    }
    if(trigger&&!isTouch){
      var shxCloseT;
      item.addEventListener('mouseenter',function(){
        clearTimeout(shxCloseT);
        root.querySelectorAll('[data-shx-item].is-open').forEach(function(o){if(o!==item){o.classList.remove('is-open');var ot=o.querySelector('[data-shx-trigger]');if(ot)ot.setAttribute('aria-expanded','false');}});
        item.classList.add('is-open');trigger.setAttribute('aria-expanded','true');
      });
      item.addEventListener('mouseleave',function(){
        clearTimeout(shxCloseT);
        shxCloseT=setTimeout(function(){item.classList.remove('is-open');trigger.setAttribute('aria-expanded','false');},200);
      });
    }
    item.addEventListener('focusin',function(){item.classList.add('is-open');if(trigger)trigger.setAttribute('aria-expanded','true');});
    item.addEventListener('focusout',function(e){if(!item.contains(e.relatedTarget)){item.classList.remove('is-open');if(trigger)trigger.setAttribute('aria-expanded','false');}});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){root.querySelectorAll('[data-shx-item].is-open').forEach(function(o){o.classList.remove('is-open');});}});
  document.addEventListener('click',function(e){if(!e.target.closest('[data-shx-item]')){root.querySelectorAll('[data-shx-item].is-open').forEach(function(o){o.classList.remove('is-open');});}});

  /* Search */
  var search=root.querySelector('[data-shx-search]');
  var sInput=root.querySelector('[data-shx-search-input]');
  var sResults=root.querySelector('[data-shx-search-results]');
  root.querySelectorAll('[data-shx-open-search]').forEach(function(b){b.addEventListener('click',function(){open(search);setTimeout(function(){sInput&&sInput.focus();},120);});});
  root.querySelectorAll('[data-shx-close-search]').forEach(function(b){b.addEventListener('click',function(){close(search);});});
  var sAll=root.querySelector('[data-shx-search-all]');
  var sAllLink=root.querySelector('[data-shx-search-all-link]');
  /* Chips sind echte Links (/search?q=…). Mit JS bleiben wir im Overlay. */
  root.querySelectorAll('[data-shx-term]').forEach(function(c){c.addEventListener('click',function(e){if(!sInput)return;e.preventDefault();sInput.value=c.textContent.trim();doSearch();sInput.focus();});});
  var st;
  function showAll(q){
    if(!sAll||!sAllLink)return;
    if(q){sAllLink.setAttribute('href','/search?q='+encodeURIComponent(q)+'&type=product');sAll.hidden=false;}
    else{sAll.hidden=true;}
  }
  function doSearch(){
    var q=(sInput.value||'').trim();
    if(q.length<2){sResults.innerHTML='';showAll('');return;}
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
      .then(function(r){return r.json();})
      .then(function(d){
        var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        showAll(q);
        if(!items.length){sResults.innerHTML='<p class="shx-search__empty">Keine Treffer für „'+q+'“. Probier einen anderen Begriff.</p>';return;}
        sResults.innerHTML=items.slice(0,8).map(function(p){
          var img=p.featured_image&&p.featured_image.url?p.featured_image.url:(p.image||'');
          var price=(p.price!=null)?moneyDec(p.price):'';var priceVaries=(p.price_min!=null&&p.price_max!=null&&p.price_min!==p.price_max);if(price&&priceVaries){price='ab '+price;}
          return '<a class="shx-sr" href="'+p.url+'"><span class="shx-sr__img">'+(img?'<img src="'+img+'&width=300" alt="" loading="lazy">':'')+'</span><span class="shx-sr__t">'+p.title+'</span><span class="shx-sr__p">'+price+'</span></a>';
        }).join('');
      }).catch(function(){});
  }
  if(sInput){sInput.addEventListener('input',function(){clearTimeout(st);st=setTimeout(doSearch,180);});}

  /* Cart drawer */
  var cartD=root.querySelector('[data-shx-cart]');
  var cartBody=root.querySelector('[data-shx-cart-body]');
  var cartFoot=root.querySelector('[data-shx-cart-foot]');
  var cartSub=root.querySelector('[data-shx-cart-sub]');
  var cartCounts=root.querySelectorAll('[data-shx-cart-count]');
  function renderCart(c){
    if(!cartBody)return;
    cartCounts.forEach(function(el){el.textContent=c.item_count;el.classList.toggle('is-empty',c.item_count===0);});
    var budmat=root.querySelector('[data-shbh-cart]');
    if(budmat)budmat.hidden=!(c.items&&c.items.some(function(i){return i.vendor==='Budmat';}));
    if(!c.items||!c.items.length){cartBody.innerHTML='<div class="shx-cartd__empty">Dein Warenkorb ist noch leer.</div>';cartFoot.hidden=true;return;}
    cartFoot.hidden=false;cartSub.textContent=money(c.items_subtotal_price!=null?c.items_subtotal_price:c.total_price);
    cartBody.innerHTML=c.items.map(function(it){
      var img=it.image?it.image:'';
      var vt=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="shx-ci__v">'+it.variant_title+'</div>':'';
      return '<div class="shx-ci" data-key="'+it.key+'">'+
        '<a class="shx-ci__img" href="'+it.url+'">'+(img?'<img src="'+img+'&width=140" alt="" loading="lazy">':'')+'</a>'+
        '<div><a class="shx-ci__t" href="'+it.url+'">'+it.product_title+'</a>'+vt+
        '<div class="shx-ci__qty"><button type="button" data-shx-dec aria-label="Weniger">'+svgMinus+'</button><span>'+it.quantity+'</span><button type="button" data-shx-inc aria-label="Mehr">'+svgPlus+'</button></div></div>'+
        '<div class="shx-ci__right"><span class="shx-ci__price">'+money(it.final_line_price)+'</span><button class="shx-ci__rm" type="button" data-shx-rm>Entfernen</button></div>'+
      '</div>';
    }).join('');
  }
  var svgPlus='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M12 5v14M5 12h14"/></svg>';
  var svgMinus='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12h14"/></svg>';
  function fetchCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){renderCart(c);return c;});}
  function changeQty(key,qty){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){renderCart(c);return c;});}
  /* Warenkorb-Icon ist ein echter Link auf /cart; mit JS öffnen wir stattdessen den Drawer.
     Cmd/Ctrl/Shift/Mittelklick bleiben als „in neuem Tab öffnen" erhalten. */
  root.querySelectorAll('[data-shx-open-cart]').forEach(function(b){b.addEventListener('click',function(e){
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button===1)return;
    e.preventDefault();open(cartD);fetchCart();
  });});
  root.querySelectorAll('[data-shx-close-cart]').forEach(function(b){b.addEventListener('click',function(){close(cartD);});});
  if(cartBody){cartBody.addEventListener('click',function(e){
    var row=e.target.closest('.shx-ci');if(!row)return;var key=row.getAttribute('data-key');var qtyEl=row.querySelector('.shx-ci__qty span');var q=parseInt(qtyEl.textContent,10)||1;
    if(e.target.closest('[data-shx-inc]'))changeQty(key,q+1);
    else if(e.target.closest('[data-shx-dec]'))changeQty(key,Math.max(0,q-1));
    else if(e.target.closest('[data-shx-rm]'))changeQty(key,0);
  });}
  /* Intercept add-to-cart forms site-wide -> AJAX + open drawer */
  document.addEventListener('submit',function(e){
    var form=e.target;if(!form||form.getAttribute('action')==null)return;
    if(form.getAttribute('action').indexOf('/cart/add')===-1)return;
    e.preventDefault();
    /* Capture-Phase: verhindert, dass <product-form> denselben Submit ein zweites Mal verarbeitet (sonst doppelter Warenkorb-Eintrag). */
    e.stopPropagation();
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){return r.json();})
      .then(function(){open(cartD);return fetchCart();})
      .catch(function(){form.submit();});
  },true);
  fetchCart();

  /* Mobile drawer + multi-level */
  var mob=root.querySelector('[data-shx-mobile]');
  var stage=root.querySelector('[data-shx-stage]');
  var stack=['root'];
  function showPane(name){
    if(!stage)return;
    stage.querySelectorAll('.shx-mob__pane').forEach(function(p){
      var n=p.getAttribute('data-pane');
      var pos=stack.indexOf(n);
      var isActive=(n===name);
      p.classList.toggle('is-active',isActive);
      p.classList.toggle('is-left', !isActive && pos!==-1 && pos < stack.length-1);
    });
    stage.scrollTop=0;
  }
  root.querySelectorAll('[data-shx-open-menu]').forEach(function(b){b.addEventListener('click',function(){open(mob);stack=['root'];showPane('root');});});
  root.querySelectorAll('[data-shx-close-menu]').forEach(function(b){b.addEventListener('click',function(){close(mob);});});
  if(stage){
    stage.addEventListener('click',function(e){
      var to=e.target.closest('[data-shx-to]');
      if(to){var t=to.getAttribute('data-shx-to');stack.push(t);showPane(t);return;}
      var back=e.target.closest('[data-shx-back]');
      if(back){stack.pop();showPane(stack[stack.length-1]||'root');return;}
    });
  }

  /* Global ESC / backdrop close already wired; ensure ESC closes overlays */
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){[search,cartD,mob].forEach(function(el){if(el&&el.classList.contains('is-open'))close(el);});}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["she-pdp-details"]) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-shd]').forEach(function(root){
      if(root.__shd)return; root.__shd=1;
      root.querySelectorAll('.shd__mf details').forEach(function(d){d.setAttribute('open','');});
      root.querySelectorAll('.shd__head').forEach(function(btn){
        btn.addEventListener('click',function(){
          var item=btn.closest('.shd__item');
          var open=item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded',open?'true':'false');
        });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
